import React from 'react'
import styled from 'styled-components'

import theme from '../utils/theme'

const Message = styled.p`
  text-align: center;
  padding: 0.75rem 1.5rem;
  background-color: ${theme.colors.teal};
  color: white;
  font-family: ${theme.fonts.sans};
`

const MessageComponent = ({children, style}) => (
  <Message style={style}>
    {children}
  </Message>
)

export default MessageComponent



// WEBPACK FOOTER //
// ./src/components/message.js